// Neil Dunlop Consulting — Design Tokens
// Mirrors the NDC brand style guide

export const T = {
  // Accent (single brand color)
  accent: "#8B1A1A",
  accentDark: "#6E1414",
  accentGlow: "rgba(139, 26, 26, 0.15)",
  accentMuted: "rgba(139, 26, 26, 0.4)",
  accentSubtle: "rgba(139, 26, 26, 0.06)",

  // Backgrounds - warmer, more distinct hierarchy
  cream: "#FAF8F5",          // slightly warmer base
  creamMid: "#F3EFE9",       // NEW: distinct mid-tone for panels
  creamDark: "#EBE6DE",      // more visible contrast
  surface: "#FFFFFF",        // card surfaces
  deep: "#0F1419",
  deepMid: "#171E26",
  deepLight: "#1E2832",

  // Text - slightly warmer, better contrast
  textDark: "#1A1A1A",       // softer than pure near-black
  textBody: "#3D3D3D",       // NEW: warmer body text, better readability
  textMid: "#5C5C5C",        // warmer gray
  textLight: "#8A8A8A",      // warmer caption gray
  textOnDark: "#C8D0DA",

  // Borders - warmer
  borderLight: "#DDD8D0",    // warmer, more visible
  borderMid: "#CCC7BE",      // NEW: for more emphasis
  borderDark: "rgba(255,255,255,0.08)",

  // Legacy aliases (for compatibility during transition)
  ground: "#0F1419",
  groundDeep: "#171E26",
  panel: "#F3EFE9",
  paper: "#FAF8F5",
  paperDim: "#5C5C5C",
  ink: "#1A1A1A",
  amber: "#8B1A1A",
  amberDeep: "#6E1414",
  cyan: "#8B1A1A",
  cyanDeep: "#6E1414",
  line: "#DDD8D0",
  danger: "#8B1A1A",
  good: "#4A7C59",
};

// Color function - now returns single accent
export const C = () => T.accent;

export const fonts = {
  display: "'Bricolage Grotesque', sans-serif",
  body: "'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  mono: "'Outfit', monospace",
};

// Layout
export const layout = {
  container: "1200px",
  containerNarrow: "800px",
  sectionPad: "7rem 2.5rem",
  sectionPadSm: "5rem 2.5rem",
  radius: 0,
  borderAccent: "4px",
  kickerRule: "30px",
};

// Type scale
export const type = {
  hero: "clamp(2.5rem, 5vw, 4rem)",
  xl: "clamp(2.2rem, 4vw, 3.2rem)",
  lg: "clamp(1.8rem, 3vw, 2.4rem)",
  stat: "clamp(3rem, 5vw, 4.5rem)",
  kicker: "0.8rem",
};
